<template>
  <div>
    <h3 class="home label-dark">
      {{ $t('component.registryCaseWizard.wizardQuestion') }}
    </h3>
    <div class="mt-5">
      <b-row>
        <b-col class="d-flex flex-column align-items-center">
          <div
            class="wizard-button home"
            qa="registry-wizard-sample-button"
            @click="$emit('addSampleAndGoToThirdStep')"
          >
            <i
              class="fal fa-prescription-bottle"
              aria-hidden="true"
            />
          </div>
          <p>{{ $tc('global.sample', 1) }}</p>
        </b-col>
        <b-col class="d-flex flex-column align-items-center">
          <div
            class="wizard-button home"
            qa="registry-wizard-block-button"
            @click="$emit('addPortionAndGoToThirdStep')"
          >
            <i
              class="icon-block"
              aria-hidden="true"
            />
          </div>
          <p>{{ $tc('component.registryCaseWizard.portion', 1) }}</p>
        </b-col>
        <b-col class="d-flex flex-column align-items-center">
          <div
            class="wizard-button home"
            qa="registry-wizard-slide-button"
            @click="$emit('addSubportionAndGoToThirdStep')"
          >
            <i
              class="icon-porta"
              aria-hidden="true"
            />
          </div>
          <p>{{ $tc('component.registryCaseWizard.subportion', 1) }}</p>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="d-flex justify-content-start">
          <b-button
            class="btn__link"
            qa="registry-wizard-back-button"
            @click="$emit('goToFirstStep')"
          >
            <!-- TODO: Translation refactoring required -->
            <i
              class="far fa-arrow-left mr-2"
              aria-hidden="true"
            />{{ $t('diagnosis.batchActionsModal.back') }}
          </b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
    name: 'RegistryWizardSecondStep'
}
</script>

<style scoped>

</style>
